//CLIENT
import {
    Navbar, Nav, NavDropdown, Form, FormControl, Button, Container, Row, Col,
    Card, Image,Modal,

} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    Redirect,
    NavLink,
} from "react-router-dom";
import Home from "./page/home";
import Room from "./page/room";
import Booking from "./page/booking";
import Rule from "./page/rule";
import Login, {ssoNextLogin} from "./page/login";
import Admin from "./page/admin";
import Contact from "./page/contact";
import Manual from "./page/manual";
import Status from "./page/status";
import Calendar from "./page/calendar";
import Report from "./page/report";
import './main.css';
import StateContext from "./mobx/global-context";
import MobxStore from "./mobx/mobx-store";
import {observer} from "mobx-react";
import React, {useEffect, useState} from "react";
import axios from "axios";
import {checkLogin, requestAPI} from "./services";
import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import pkg from './../package.json'
import 'react-confirm-alert/src/react-confirm-alert.css';
import {ImFacebook2} from "react-icons/im";
import moment from 'moment';
import mobxStore from "./mobx/mobx-store";

function App() {
    const [expanded, setExpanded] = useState(true);
    const [myBookings, setMyBookings] = useState([]);
    const [activeSurvey, setActiveSurvey] = useState(null);

    useEffect(() => {
        let qrMatched = document.location.href.match(/qr=(.+)$/);
        if (qrMatched) {
            localStorage.setItem('qr', qrMatched[1]);
        }
        checkLogin().then((me) => {
            if (me) {
                MobxStore.setCurrentUser(me);
            }
        }).catch(e => {
            MobxStore.setCurrentUser(null);
        });
        loadMyBooking();
    }, []);

    const loadMyBooking=()=>{
        requestAPI('GET','/my_bookings').then(data=>{
            setMyBookings(data);
            for(let booking of data){
                let pastMonth = moment(booking.startDate).diff(new Date(),'month');
                if(Math.abs(pastMonth)>2)continue;
                let pastTimeHours = moment(booking.startDate).diff(new Date(),'hours');
                if(!booking.survey && booking.booking_status.id==1 && Math.abs(pastTimeHours)>=24){
                    MobxStore.setShowSurvey(booking.id);
                    setActiveSurvey(data.find(b=>b.id==booking.id));
                    break;
                }
            }
        });
    }

    const submitSurvey=(id)=>{
        mobxStore.setShowSurvey(null);
        requestAPI('POST','/save_survey', {id}).then(data=>{
        })
    }

    if (typeof MobxStore.currentUser === 'undefined') return <div>Loading....</div>

    return (
        <StateContext.Provider value={MobxStore}>
            <Router basename={pkg.base_name}>
                {MobxStore.navBar && <Navbar bg="dark" variant="dark" expand="xl" expanded={expanded} onToggle={ex => {
                    setExpanded(ex)
                }}>
                    <Navbar.Brand href="/booking/login">
                        <img src={`${pkg.homepage}/logo2.png`} height="35"/>
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav"/>
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="mr-auto">
                            {MobxStore.currentUser &&
                            <>
                                <NavLink to="/room" className="nav-link">ห้อง Smart Classroom & Studio</NavLink>
                            </>
                            }
                            <NavLink to="/rule" className="nav-link">หลักเกณฑ์การใช้งาน</NavLink>
                            <NavLink to="/manual" className="nav-link">วิธีการจองห้อง</NavLink>
                            {/*<NavLink to="/status" className="nav-link">สถานะห้อง</NavLink>*/}
                            <NavLink to="/contact" className="nav-link">ติดต่อ</NavLink>

                            {MobxStore.currentUser &&
                            <>
                                {/*<a href="https://forms.gle/SgWtCKtSRSUFfbAT6" className="nav-link" target="_blank">แบบประเมิน</a>*/}
                                <NavDropdown title="รายงาน" id="basic-nav-dropdown">
                                    <a href="https://forms.gle/SgWtCKtSRSUFfbAT6" className="dropdown-item" target="_blank">แบบประเมินความพึงพอใจ</a>
                                    <NavDropdown.Divider/>
                                    <NavLink to="/report" className="dropdown-item">รายงานการใช้งานห้อง</NavLink>
                                </NavDropdown>
                            </>
                            }

                            {
                                MobxStore.currentUser?.role.id == 3 ?
                                    // <NavLink to="/admin" className="nav-link">จัดการสถานะการจอง (Admin)</NavLink>
                                    <NavDropdown title="สำหรับเจ้าหน้าที่" id="basic-nav-dropdown">
                                        <Link to="/admin" role="button" className="dropdown-item">จัดการสถานะการจอง</Link>
                                        <NavDropdown.Divider/>
                                        <NavLink to="/calendar" className="dropdown-item">ปฎิทินห้องทั้งหมด</NavLink>
                                    </NavDropdown>
                                    :
                                    null
                            }
                        </Nav>
                        {
                            MobxStore.currentUser ?
                                <Nav>
                                    <Nav.Link onClick={() => {
                                        MobxStore.logout()
                                    }} href="#">Logout : {MobxStore.currentUser.username} {
                                        MobxStore.currentUser.role.id == 3 ?
                                            <>(STAFF)</>
                                            :
                                            null
                                    }
                                    </Nav.Link>
                                </Nav>
                                :
                                <Nav>
                                    {/*<a className="nav-link" href={`${pkg.api_url}/ltic-auth`}>KKU LOGIN</a>*/}
                                    {/*<a className="bt-login" href={`${pkg.api_url}/ltic-auth`}>KKU LOGIN</a>*/}
                                    <a className="bt-login" onClick={e=>{
                                        e.preventDefault();
                                        ssoNextLogin();
                                    }}>KKU LOGIN</a>
                                </Nav>
                        }
                    </Navbar.Collapse>
                </Navbar>}
                <div style={{paddingBottom:100}}>
                    <Switch>
                        <Route path="/status">
                            <Status/>
                        </Route>
                        {MobxStore.currentUser ?
                            <Switch>
                                <Route exact path="/">
                                    <Container><Home/></Container>
                                </Route>

                                <Route path="/room">
                                    <Container><Room/></Container>
                                </Route>

                                <Route path="/booking/:id">
                                    <Container><Booking/></Container>
                                </Route>

                                <Route path="/rule">
                                    <Container><Rule/></Container>
                                </Route>

                                <Route path="/manual">
                                    <Container><Manual/></Container>
                                </Route>

                                <Route path="/contact">
                                    <Container><Contact/></Container>
                                </Route>

                                <Route path="/report">
                                    <Container><Report/></Container>
                                </Route>

                                {
                                    MobxStore.currentUser.role.id == 3 ?
                                        <Route path="/admin">
                                            <div className="pl-5 pr-5 pb-4"><Admin/></div>
                                        </Route>
                                        :
                                        null
                                }
                                {
                                    MobxStore.currentUser.role.id == 3 ?
                                        <Route path="/calendar">
                                            <div className="pl-5 pr-5 pb-4"><Calendar/></div>
                                        </Route>
                                        :
                                        null
                                }
                                <Redirect to="/"/>
                            </Switch>
                            :
                            <Switch>
                                <Route path="/manual">
                                    <Container>
                                        <Manual/>
                                    </Container>
                                </Route>

                                <Route path="/contact">
                                    <Container>
                                        <Contact/>
                                    </Container>
                                </Route>

                                <Route path="/rule">
                                    <Container>
                                        <Rule/>
                                    </Container>
                                </Route>

                                <Route path="/login">
                                    <Login/>
                                </Route>

                                <Redirect to="/login"/>
                            </Switch>
                        }
                    </Switch>
                    <ToastContainer/>
                    <Modal backdrop='static'  size='lg' show={!!MobxStore.showSurvey} onHide={e=>MobxStore.setShowSurvey(false)}>
                        <Modal.Header>
                            <Modal.Title>การใช้บริการ{activeSurvey?.booking_room?.name} ของท่าน</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            หลังจากการใช้บริการห้องของท่าน ในวันที่ {activeSurvey?.startDate} เวลา {activeSurvey?.startTime?.replace(':00.000','')} น.
                            ขอความร่วมมือผู้ใช้บริการทำประเมินความพึงพอใจ เพื่อนําข้อมูลไปปรับปรุงพัฒนาให้ดียิ่งขึ้น
                            ขอบพระคุณค่ะ/ครับ >> <a
                            target='_blank'
                            onClick={e=>submitSurvey(MobxStore.showSurvey)}
                            href='https://docs.google.com/forms/d/e/1FAIpQLSf3flRtxUecSQtjF8oJhXfy2fcNtz0XnxdjoKv6C6om91K2yg/viewform'>
                            คลิกทำแบบประเมินความพึงพอใจ</a>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={e=>MobxStore.setShowSurvey(false)}>
                                Close
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
                <footer>
                    {/*<div className="mb-2">*/}
                    {/*    <ImFacebook2 size={20} className="mr-3" />*/}
                    {/*    <ImFacebook2 size={20} className="mr-3"/>*/}
                    {/*    <ImFacebook2 size={20} className="mr-3"/>*/}
                    {/*</div>*/}
                    <div style={{fontSize:"0.9rem"}}>
                        Copyright © KKU Learning and Teaching Innovation Center
                    </div>
                </footer>
            </Router>
        </StateContext.Provider>
    );
}

export default observer(App);
